import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import list from './subordinate-list';
import selectedRetailer from './selected-retailer';


const subordinateList = combineReducers({
  list,
  selectedRetailer,
  isLoading: loadingStatusAccordingToReducer('subordinateListLoadingStatus'),
});

export default subordinateList;



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/reducers/subordinate-list-combine.js